import { render, staticRenderFns } from "./business_time.vue?vue&type=template&id=5b28eef6&scoped=true&"
import script from "./business_time.vue?vue&type=script&lang=ts&"
export * from "./business_time.vue?vue&type=script&lang=ts&"
import style0 from "./business_time.vue?vue&type=style&index=0&id=5b28eef6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b28eef6",
  null
  
)

export default component.exports